<snelstart-ui-button type="secondary"
                     class="custom-input-150"
                     icon="plus"
                     (click)="this.showDialog()">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition id="lg" title="Specificatie egalisatiereserve" size="xl"
                                [(visible)]="dialogVisible">
    <snelstart-ui-dialog-body>
        <form [formGroup]="specGarantieVoorzieningFG">
            <div class="left">
                <div class="row">
                    <div class="col col-1">
                        <p>Bedrag volgens openingsbalans</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control formControlName="waardeOpening"
                                                          class="custom-input-150"
                                                          [decimals]="0"
                                                          align="right"
                                                          prefix="€"
                                                          (change)="saveForm()"

                        >
                        </snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </form>

        <form [formGroup]="ondernemingFG">
            <ng-container formArrayName="ondernemingen">
                <ng-container *ngFor="let onderneming of ondernemingen.controls; let i = index "
                              [formGroupName]="i">
                    <div>
                        <div class="row">
                            <div class="col col-1">
                                <p>Bij: Dotatie</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control formControlName="dotatieEgalisatiereserve"
                                                                  id="dotatieKER"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  prefix="€"
                                                                  align="right"
                                                                  (change)="saveForm()"

                                >
                                </snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                    <div class="left">
                        <div class="row">
                            <div class="col col-1">
                                <p>Af: onttrekking</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control formControlName="vrijvalEgalisatiereserve"
                                                                  id="vrijvalHIR"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€ -"
                                                                  (change)="saveForm()"

                                >
                                </snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </form>
        <form [formGroup]="specGarantieVoorzieningFG">
            <div class="left">
                <div class="row">
                    <div class="col col-1">
                        <p>Bedrag volgens slotbalans</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control formControlName="waardeSlot"
                                                          class="me-1 custom-input-150 custom-readonly"
                                                          [disabledControl]="true"
                                                          [decimals]="0"
                                                          prefix="€"
                                                          align="right"
                                                          (change)="saveForm()"

                        >
                        </snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </form>


        <hr class="line-color pt-3">

        <div>

            <p>Specificatie van bedrag volgens openingsbalans</p>

        </div>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button id="cancel" class="me-2" type="secondary" btn-x>Annuleren</snelstart-ui-button>
        <snelstart-ui-button id="save" type="primary" icon="check" [submit]="true">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
